import { put, call } from 'redux-saga/effects';
import { Types } from './actions';
import ReservationDataRepository from '../../../../data/repositories/ReservationDataRepository';
import ReservationRepository from '../../../repositories/ReservationRepository';
import { arrayResources } from '../getSubscribedsTabletsUseCase/saga';

export default function* execute({ id }: any): any {
  try {
    yield put({ type: Types.GET_RESERVATION_DETAIL_REQUEST });
    const repository: ReservationRepository = new ReservationDataRepository();
    const response = yield call(repository.getTabletDetail, id);

    if (!response) {
      yield put({
        type: Types.GET_RESERVATION_DETAIL_FAILURE,
        error: 'No se pudo leer los datos.'
      });
      return;
    }
    const newResponse = {
      reservationDetail: {
        ...response.reservationDetail,
        resourceName: arrayResources[response?.reservationDetail?.type]
      }
    };
    yield put({
      type: Types.GET_RESERVATION_DETAIL_SUCCESS,
      data: newResponse
    });
  } catch (error) {
    yield put({
      type: Types.GET_RESERVATION_DETAIL_FAILURE,
      error: 'Ocurrió un error al momento de leer los datos.'
    });
  }
}
